export const ADD_PAGES = 'pages/add-pages';
export const REMOVE_PAGE = 'pages/remove-page';
export const SET_PAGE_LOADING = 'pages/set-page-loading';
export const SET_PAGE_LOADED = 'pages/set-page-loaded';
export const SET_PAGE_EXPANDED = 'pages/set-page-expanded';
export const SET_PAGE_PARENT = 'pages/set-page-parent';
export const MOVE_PAGE = 'pages/move-page';
export const SET_FREE_PAGES = 'pages/set-free-pages';
export const SET_SELECTED_PAGE = 'pages/set-selected-page';
export const SET_REFERENCES_SELECTED_PAGE = 'pages/set-references-selected-page';
export const UPDATE_PAGE = 'pages/update-page';
export const SEARCH_PAGES = 'pages/search-pages';
export const CLEAR_SEARCH = 'pages/clear-search';
export const CLEAR_TREE = 'pages/clear-tree';
export const BATCH_TOGGLE_EXPANDED = 'pages/set-all-pages-expanded';
export const COLLAPSE_ALL = 'pages/collapse-all-pages';
export const SET_VIEWPAGES = 'pages/set-viewpages';
export const SET_DASHBOARD_PAGES = 'pages/set-dashboard-pages';
export const SET_VIRTUAL_ROOT = 'pages/set-virtual-root';
export const SET_ROOT_PAGE = 'pages/set-root-page';
